/* Boutique Locations section (sections/boutique-locations.liquid)
   - Store pills expand/collapse their details (one open at a time).
   - On mobile, state groups are collapsible (first open by default; desktop
     shows every group and the CSS turns the toggles into plain headings).
   - "Suggest a boutique" opens a native <dialog>; after Shopify re-renders the
     page from the contact form POST, the dialog reopens to show the result. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 989px)');

  function init(root) {
    if (root.dataset.blReady === '1') return;
    root.dataset.blReady = '1';

    /* ---- store pills */
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-bl-pill]'));
    function setPill(pill, open) {
      var panel = document.getElementById(pill.getAttribute('aria-controls'));
      pill.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var open = pill.getAttribute('aria-expanded') !== 'true';
        pills.forEach(function (p) { if (p !== pill) setPill(p, false); });
        setPill(pill, open);
      });
    });

    /* ---- state groups (mobile accordion) */
    var stateToggles = Array.prototype.slice.call(root.querySelectorAll('[data-bl-state-toggle]'));
    function setState(btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }
    function applyLayout() {
      if (MOBILE.matches) {
        // One group open at a time. Coming from desktop (everything open) or
        // from nothing open, fall back to the first state.
        var openCount = stateToggles.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; }).length;
        stateToggles.forEach(function (b, i) {
          b.removeAttribute('tabindex');
          setState(b, openCount === 1 ? b.getAttribute('aria-expanded') === 'true' : i === 0);
        });
      } else {
        // Desktop: every group visible, toggles are just headings.
        stateToggles.forEach(function (b) {
          setState(b, true);
          b.setAttribute('tabindex', '-1');
        });
      }
    }
    stateToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!MOBILE.matches) return;
        var open = btn.getAttribute('aria-expanded') !== 'true';
        stateToggles.forEach(function (b) { if (b !== btn) setState(b, false); });
        setState(btn, open);
        // Collapse any store left open inside a group that just closed.
        if (!open) pills.forEach(function (p) { setPill(p, false); });
      });
    });
    applyLayout();
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', applyLayout);
    else MOBILE.addListener(applyLayout);

    /* ---- pop-up forms (Suggest a boutique, Apply for wholesale) */
    var dialogs = Array.prototype.slice.call(root.querySelectorAll('[data-bl-dialog]'));
    if (!dialogs.length || typeof dialogs[0].showModal !== 'function') return;
    var lastOpener = null;

    function showThanks(dialog, on) {
      var thanks = dialog.querySelector('[data-bl-thanks]');
      var body = dialog.querySelector('[data-bl-formbody]');
      if (thanks) thanks.hidden = !on;
      if (body) body.hidden = !!on;
    }
    function resetDialog(dialog) {
      // Back to a blank form so it can be sent again.
      showThanks(dialog, false);
      var errors = dialog.querySelector('[data-bl-errors]');
      if (errors) errors.remove();
      dialog.querySelectorAll('input:not([type="hidden"])').forEach(function (i) {
        i.value = '';
        i.removeAttribute('aria-invalid');
      });
    }
    function openDialog(dialog, opener) {
      lastOpener = opener || null;
      document.documentElement.classList.add('bl-dialog-open');
      if (!dialog.open) dialog.showModal();
      // Autofocus inside the dialog normally handles this; fallback for browsers that ignore it.
      setTimeout(function () {
        var focusTarget = dialog.querySelector('[role="alert"]') || dialog.querySelector('input:not([type="hidden"])') || dialog.querySelector('button');
        if (focusTarget && !dialog.contains(document.activeElement)) focusTarget.focus();
      }, 50);
    }
    function afterClose(dialog) {
      document.documentElement.classList.remove('bl-dialog-open');
      var opener = lastOpener || root.querySelector('[data-bl-dialog-open="' + dialog.getAttribute('data-bl-dialog') + '"]');
      if (opener) opener.focus({ preventScroll: true });
      resetDialog(dialog);
      // Once the thank-you / errors have been seen, drop ?contact_posted=true and
      // the form hash so a refresh doesn't show them again.
      if (window.history && (/contact_posted=/.test(location.search) || location.hash)) {
        var search = location.search.replace(/[?&]contact_posted=[^&]*/, '').replace(/^&/, '?');
        window.history.replaceState(null, '', location.pathname + search);
      }
    }
    function closeDialog(dialog) {
      if (dialog.open) dialog.close();
      afterClose(dialog);
    }

    root.querySelectorAll('[data-bl-dialog-open]').forEach(function (btn) {
      var target = root.querySelector('[data-bl-dialog="' + btn.getAttribute('data-bl-dialog-open') + '"]');
      if (target) btn.addEventListener('click', function () { openDialog(target, btn); });
    });

    dialogs.forEach(function (dialog) {
      dialog.querySelectorAll('[data-bl-dialog-close]').forEach(function (b) {
        b.addEventListener('click', function () { closeDialog(dialog); });
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeDialog(dialog); // backdrop
      });
      // Escape: the browser closes the dialog itself; run the same cleanup.
      dialog.addEventListener('cancel', function () { setTimeout(function () { afterClose(dialog); }, 0); });
      dialog.addEventListener('close', function () { afterClose(dialog); });
    });

    // After a form POST, Shopify sends the page back with ?contact_posted=true (success)
    // or re-renders it with errors, keeping the posted form's id in the hash. Both
    // flags are page-wide, so only the dialog matching the hash shows the result;
    // the other one is reset to a blank form.
    var success = /contact_posted=true/.test(location.search) || dialogs.some(function (d) { return d.hasAttribute('data-posted'); });
    var errored = !!root.querySelector('[data-bl-errors]');
    if (success || errored) {
      var target = dialogs.filter(function (d) { return '#' + d.getAttribute('data-form-id') === location.hash; })[0] || dialogs[0];
      dialogs.forEach(function (d) { if (d !== target) resetDialog(d); });
      if (success) showThanks(target, true);
      openDialog(target);
    }
  }

  function initAll() {
    document.querySelectorAll('.bl[data-section-id]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.bl[data-section-id]');
    if (root) init(root);
  });
})();
